import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalMorphologyModel} from '../../../api/model/medicalMorphology.model';
import {MedicalMorphologyConverter} from '../../../api/model/converter/medicalMorphology.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class MedicalMorphologyDataService extends AbstractDataServiceV2<MedicalMorphologyModel, MedicalMorphologyConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalMorphologyConverter) {
        super('MedicalMorphology', http, httpUrlGenerator, logger, config, converter);
    }
}
